import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useCurrentUser } from '@bonusly/who-am-i';

import { QueryKey } from '../types/team-management-types';

interface ManagerCheckInSettings {
	cadence: string;
	scheduled_at: string;
}

interface ManagerData {
	manager_check_in_settings?: ManagerCheckInSettings;
}

export const useManagerCheckInSettings = () => {
	const user = useCurrentUser();
	const http = useHttpClient('v2');

	return useQuery({
		queryKey: [QueryKey.ManagerCheckInSettings, user.manager_id],
		queryFn: async () => {
			const response = await http.get<ManagerData>(`/user_management/users/${user.manager_id}`);
			return response.data;
		},
		enabled: !!user.manager_id,
		select: (data) => data.manager_check_in_settings,
	});
};
